import React from 'react';
/**
 * H1 heading for the Wacoku Products category page.
 */
export function Heading() {
  return <h1 className="text-4xl sm:text-5xl font-black text-gray-900 uppercase tracking-tight mb-6" data-id="element-972">
      Wacoku Products
    </h1>;
}